/**
 * Fisheye
 */
export const Fisheye = ({ focusX = 0, focusY = 0, distortionX = 2, distortionY = 2, visual = false, }) => [['fisheye', focusX, focusY, distortionX, distortionY, visual]];
Fisheye.props = { transform: true };
//# sourceMappingURL=fisheye.js.map